<template>
  <f7-page
    :theme-dark="dark"
    id="search"
    @page:afterin="pageAfterIn">

    <f7-navbar
      large
      back-link
      :theme-dark="dark"
      :title="title" />

    <SearchGeonames
      ref="SearchGeonames"
      @change="change"
      @click="click" />
  </f7-page>
</template>

<script>
import { mapActions } from 'vuex'
import SearchGeonames from '@/components/io/SearchGeonames'
export default {
  name: 'Search',
  components: {
    SearchGeonames
  },
  data () {
    return {
      term: ''
    }
  },
  computed: {
    title () {
      return this.term ? this.term : 'Search'
    }
  },
  methods: {
    ...mapActions({
      setSetting: 'global/setSetting',
      setFlyTo: 'global/setFlyTo'
    }),
    change (val) {
      this.term = val
    },
    pageAfterIn () {
      this.$refs.SearchGeonames.focus()
    },
    click (city) {
      this.setFlyTo(city)
      this.setSetting({ center: city, follow: false })
      this.$f7router.back()
    }
  }
}
</script>

<docs>
```js
<Search />
```
</docs>
